import StoreProductionHistoryPanel from "./StoreProductionHistoryPanel";

export default function StoreProductionTab() {
  return <StoreProductionHistoryPanel mode="store" />;
}
